import React from "react";
import { Card, CardContent, Box, Checkbox } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import SourcesShrinkSvg from "../../assets/images/sources_shrink_icon.svg";
import DashboardStyles from "./Dashboard.module.scss";
import BackArrowSvg from "../../assets/images/back_arrow_icon.svg";
import PlusSvg from "../../assets/images/plus_icon.svg";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "../../components/Tooltip/Tooltip";

export interface SourceItem {
  id: string;
  name: string;
  selected: boolean;
  isSelectAll?: boolean;
}

interface SourcesSelectionProps {
  sources: SourceItem[];
  onSourceToggle: (id: string) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  selectedModel: string;
  onModelChange: (model: string) => void;
}

const SourcesSelection: React.FC<SourcesSelectionProps> = ({
  sources,
  onSourceToggle,
  isCollapsed,
  onToggleCollapse,
  selectedModel,
  onModelChange,
}) => {
  if (isCollapsed) {
    return (
      <div className={DashboardStyles.sourcesShrinkContainer}>
        <img src={SourcesShrinkSvg} alt="" onClick={onToggleCollapse} />
      </div>
    );
  }

  const handleModelChange = (
    event: React.MouseEvent<HTMLElement>,
    newModel: string | null
  ) => {
    if (newModel !== null) {
      onModelChange(newModel);
    }
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        background: "#FFFFFF99",
        borderRadius: "16px",
        boxShadow: "none",
      }}
    >
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="16px"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={BackArrowSvg}
              alt=""
              onClick={onToggleCollapse}
              style={{ cursor: "pointer" }}
            />
            <Typography
              fontWeight={500}
              fontSize={"14px"}
              color="#282B31"
              lineHeight="16px"
            >
              Sources
            </Typography>
          </div>
        </Box>

        <Tooltip title="Coming Soon!" placement="right">
          <span>
            <Button
              variant="outlined"
              startIcon={<AddIcon sx={{ color: "grey.500" }} />}
              style={{
                borderRadius: "24px",
                padding: "6px 16px",
                fontWeight: "500",
                fontSize: "12px",
                fontFamily: "Google Sans",
                lineHeight: "16px",
              }}
              disabled={true}
            >
              Add Source
            </Button>
          </span>
        </Tooltip>

        <Box mt={1}>
          {sources.map((source) => (
            <Box
              key={source.id}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1,
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  borderRadius: 1,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontFamily: "400",
                  fontWeight: "12px",
                }}
              >
                <Typography fontWeight={400} fontSize={12} color="#282B31">
                  {source.name}
                </Typography>
                {!source.isSelectAll && (
                  <InfoOutlined
                    sx={{
                      fontSize: 16,
                      color: "text.secondary",
                      cursor: "pointer",
                    }}
                  />
                )}
              </Box>
              <Checkbox
                checked={source.selected}
                onChange={() => onSourceToggle(source.id)}
                color="primary"
                size="small"
              />
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SourcesSelection;
